module.exports = __webpack_public_path__ + "img/icon-logo.867f0e53.svg";